import React from 'react';

import Teaser from '@spp/ui-teaser-small';
import { themer } from '@spp/theme-provider';

const Bundle = ({ theme, items } = {}) => {
    const teaserBundle = items.map((teaser) => <Teaser {...teaser} />);

    return <div className={theme['nt-bundle']}>{teaserBundle}</div>;
};

export default themer('@vg/ui-nt-bundle')(Bundle);



/** WEBPACK FOOTER **
 ** ./src/local-components/article/Bundle.js
 **/